import AiStickerGenerator from "../components/page/AiStickerGenerator";
import Layout from "../components/layout/Layout";

const AIStickerGeneratorPage = () => {
    return (
        <Layout>
            <AiStickerGenerator />
        </Layout>
    );
};
export default AIStickerGeneratorPage;
